
/**
 * SEO 配置 - models (繁體中文)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - 旗艦級 AI 影片生成 | WeryAI',
        description: 'Google Veo 3.1：旗艦級 AI 影片模型，支援原生音訊、幀控制與高級場景延展。',
        keywords: 'Google Veo 3.1, 旗艦 AI 影片, 影片生成, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - 高品質 AI 影片生成 | WeryAI',
        description: 'Google Veo 3 生成高品質、逼真的影片，支援強大的動作一致性與原生音訊。',
        keywords: 'Veo 3, Google Veo, AI 影片創作, 文生影片, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - 極速 AI 影片生成 | WeryAI',
        description: '用 Google Veo 3 Fast 快速生成高畫質 AI 影片。支持角色一致性與極速渲染。',
        keywords: 'Veo 3 Fast, 極速 AI 影片, 角色一致性, 文生影片, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - 物理模擬級 AI 影片生成 | WeryAI',
        description: '體驗 OpenAI Sora 2，生成符合物理規律的超逼真影片。支持多鏡頭敘事與精準控制。',
        keywords: 'Sora 2, OpenAI Sora, 物理模擬, 逼真 AI 影片, 文生影片, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - 旗艦級原生 AI 影片產生器 | WeryAI',
        description: 'WeryAI Video 1.0：旗艦級原生 AI 影片模型，支援原生多鏡頭敘事、智慧圖生影片與物理級動作模擬。',
        keywords: 'WeryAI Video 1.0, WeryAI 原生模型, AI 影片產生器, 多鏡頭敘事, 圖生影片, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - 原生 AI 圖像生成器 | WeryAI',
        description: '使用 WeryAI Image 2 享受精美原生 AI 圖像生成！旗艦模型，高級風格控制與極致細節。免費額度，無需綁卡。',
        keywords: 'WeryAI Image 2, 原生AI圖像生成器, 旗艦AI圖像, 工作室級AI, WeryAI Image 免費, 如何使用WeryAI Image 2, WeryAI',
    },
    image_grok_2: {
        title: '免費 Grok 2 - xAI 圖像生成器 | WeryAI',
        description: '在 WeryAI 使用 Grok 2 生成創意 AI 圖像！xAI 模型具備藝術靈活性與獨特視覺風格。免費額度，無需綁卡。',
        keywords: 'Grok 2, Grok AI, xAI圖像生成, AI藝術, 創意AI圖像, Grok 2 免費, 如何使用Grok 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 圖像生成器 | WeryAI',
        description: 'Nano Banana 2 由 Gemini 驅動，結合世界知識與即時搜尋，生成事實準確、畫質精美的圖像。極速生成、超高性價比。立即在 WeryAI 免費體驗。  支援更快生成、更穩定畫質與更高可控性，適用於商業設計、行銷素材與內容生產流程。',
        keywords: 'Nano Banana 2, Google AI, Gemini, AI圖像生成器, 圖像生成, 文生圖, 文字渲染, 多主體一致性, 4K, WeryAI',
        og_title: 'Nano Banana 2 圖像生成器 | WeryAI',
        og_description: 'Nano Banana 2 由 Gemini 驅動，結合世界知識與即時搜尋，生成事實準確、畫質精美的圖像。極速生成、超高性價比。立即在 WeryAI 免費體驗。  支援更快生成、更穩定畫質與更高可控性，適用於商業設計、行銷素材與內容生產流程。',
        twitter_title: 'Nano Banana 2 圖像生成器 | WeryAI',
        twitter_description: 'Nano Banana 2 由 Gemini 驅動，結合世界知識與即時搜尋，生成事實準確、畫質精美的圖像。極速生成、超高性價比。立即在 WeryAI 免費體驗。  支援更快生成、更穩定畫質與更高可控性，適用於商業設計、行銷素材與內容生產流程。',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Nano Banana 2 AI 圖像生成器',
        twitterImageAlt: 'Nano Banana 2 AI 圖像生成器',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo - 頂級 AI 影片產生器 | WeryAI',
        description: 'Kling 2.5 Turbo 提供卓越的運鏡控制與情感表現力。創作電影級 AI 影片的首選。',
        keywords: 'Kling 2.5 Turbo, 可靈 AI, 電影級影片, 運鏡控制, 影片生成, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - 專業 AI 影片編輯與生成 | WeryAI',
        description: 'Runway Gen-4 具備深度提示語理解與風格一致性。在 WeryAI 體驗下一代 AI 影片編輯。',
        keywords: 'Runway Gen-4, Runway AI, 影片產生器, AI 影片編輯, 文生影片, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 (MiniMax) - 電商與動態 AI 影片 | WeryAI',
        description: 'Hailuo 2.3 專為動態動作與電商廣告優化。提供細膩的面部微表情與物體運動控制。',
        keywords: 'Hailuo 2.3, 海螺 AI, MiniMax, 電商影片, 動態 AI 影片, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI 影片產生器 - 高級動作控制 | WeryAI',
        description: '使用 Hailuo AI 生成高級 AI 影片。具備頂尖的動作模擬與逼真場景渲染能力。',
        keywords: 'Hailuo AI, 海螺 AI, 動作控制, 逼真影片, 影片產生器, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - 高清細膩 AI 動畫生成 | WeryAI',
        description: '在 WeryAI 體驗 Pika 2.2，生成清晰、銳利的高清 AI 動畫。非常適合精細角色創作。',
        keywords: 'Pika 2.2, Pika AI, AI 動畫, 高清影片, 影片產生器, WeryAI',
    },
    seedance: {
        title: 'Seedance AI 影片產生器 - 舞蹈與動作創作 | WeryAI',
        description: 'Seedance AI 影片產生器 - 舞蹈與動作創作 on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - 導演級 AI 影片生成器 | WeryAI',

        description: 'weryai Werydance 2.0 是導演級AI影片生成旗艦模型，支援多模態參考輸入、精準指令遵循、長鏡頭敘事一致性與物理規律模擬。在 WeryAI 免費體驗專業級AI影片創作。',

        keywords: 'Werydance 2.0, weryai, 即夢AI, AI影片生成器, 導演級控制, 多模態影片, 物理模擬, 口型同步, 文生影片, 圖生影片, 免費AI影片, WeryAI',

        og_title: 'Werydance 2.0 - 導演級 AI 影片生成器 | WeryAI',

        og_description: 'weryai Werydance 2.0 是導演級AI影片生成旗艦模型，支援多模態參考輸入、精準指令遵循、長鏡頭敘事一致性與物理規律模擬。在 WeryAI 免費體驗專業級AI影片創作。',

        twitter_title: 'Werydance 2.0 - 導演級 AI 影片生成器 | WeryAI',

        twitter_description: 'weryai Werydance 2.0 是導演級AI影片生成旗艦模型，支援多模態參考輸入、精準指令遵循、長鏡頭敘事一致性與物理規律模擬。在 WeryAI 免費體驗專業級AI影片創作。',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    wan_ai: {
        title: 'Wan AI 影片產生器 - 阿里高保真大模型 | WeryAI',
        description: 'Wan AI 影片產生器 - 阿里高保真大模型 on WeryAI. Realistic and professional results.',
        keywords: 'wan_ai, AI, WeryAI',
    },
    image_nano_banana_pro: {
        title: '免費 Nano Banana Pro - AI 圖像生成器 | WeryAI',
        description: '在 WeryAI 使用 Nano Banana Pro 獲得最高保真 AI 圖像！品質比肩 Midjourney，提示詞遵循更佳。免費額度，無需綁卡。',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google AI圖像, 推理AI圖像, 4K AI圖像, Nano Banana Pro 免費, 如何使用Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: '免費 Nano Banana - AI 圖像生成器 | WeryAI',
        description: '在 WeryAI 使用 Nano Banana 輕鬆創建 AI 圖像！快速多用的 AI 圖像模型。免費額度，無需綁卡。',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google AI圖像, 極速AI生圖, 角色一致性, Nano Banana 免費, 如何使用Nano Banana, WeryAI',
    },
    image_flux: {
        title: '免費 FLUX - 立即體驗 AI 圖像生成器 | WeryAI',
        description: '在 WeryAI 使用 FLUX 生成精美 AI 圖像！由 Stable Diffusion 團隊打造，視覺品質卓越、風格可控。免費額度，無需綁卡。',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, AI圖像生成器, 文生圖, AI繪畫, FLUX AI生圖, FLUX 免費, 如何使用FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: '免費 FLUX Kontext - 專業 AI 圖像編輯器 | WeryAI',
        description: '在 WeryAI 使用 FLUX Kontext 進行專業級 AI 圖像編輯！精準提示詞遵循、高級排版與多步編輯。免費額度，無需綁卡。',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, AI圖像編輯器, 專業AI繪圖, 排版AI, FLUX Kontext 免費, 如何使用FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: '免費 Imagen 4 - Google AI 圖像生成器 | WeryAI',
        description: '在 WeryAI 使用 Google Imagen 4 創建逼真 AI 圖像！多樣化風格控制與精準文字生成。免費額度，無需綁卡。',
        keywords: 'Imagen 4, Google Imagen, Google AI圖像, 文生圖, 寫實AI, Imagen 免費, 如何使用Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: '免費 Qwen Image - 阿里 AI 圖像模型 | WeryAI',
        description: '在 WeryAI 使用 Qwen Image 生成多語言 AI 畫作！阿里開源模型，卓越文字渲染與風格控制。免費額度，無需綁卡。',
        keywords: 'Qwen Image, 通義千問, 阿里AI圖像, 多語言文字渲染, AI繪畫, Qwen Image 免費, 如何使用Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: '免費 Wan AI - 體驗阿里圖像生成器 | WeryAI',
        description: '在 WeryAI 使用 Wan AI 創建高保真 AI 圖像！阿里模型精準提示詞遵循與寫實渲染。免費額度，無需綁卡。',
        keywords: 'Wan AI, Wan 2.5, 阿里AI圖像, 文生圖, 寫實AI圖像, Wan AI 免費, 如何使用Wan AI, WeryAI',
    },
    image_seendream: {
        title: '免費 Seedream 4.0 - 字節跳動圖像 AI | WeryAI',
        description: '在 WeryAI 使用 Seedream 4.0 極速生成 AI 圖像！字節跳動模型，多樣藝術風格與批量處理。免費額度，無需綁卡。',
        keywords: 'Seedream, Seedream 4.0, 字節跳動AI圖像, 極速AI生圖, 藝術風格AI, Seedream 免費, 如何使用Seedream, WeryAI',
    },
    image_dreamina: {
        title: '免費 Dreamina 4.0 - 多模態圖像 AI | WeryAI',
        description: '在 WeryAI 使用 Dreamina 4.0 進行多模態 AI 圖像創作！支援手繪轉圖、風格遷移與角色融合。免費額度，無需綁卡。',
        keywords: 'Dreamina 4.0, 字節跳動AI圖像, 多模態AI圖像, 手繪轉圖, 風格遷移, Dreamina 免費, 如何使用Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: '免費 Seedream 4.5 - 字節跳動圖像 AI | WeryAI',
        description: '在 WeryAI 使用 Seedream 4.5 體驗旗艦級 AI 圖像生成！字節跳動最新力作，精準排版與多圖融合。免費額度，無需綁卡。',
        keywords: 'Seedream 4.5, 字節跳動AI圖像, 旗艦AI圖像模型, 排版渲染, 多圖融合, Seedream 4.5 免費, 如何使用Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 圖像生成器 | WeryAI',
        description: 'Seedream 5.0 是字節跳動在 AI 視覺領域的巔峰之作，原生 8K 超精細畫質、極致語義理解、多主體構圖與文字渲染 2.0。立即在 WeryAI 免費體驗。  支援更快生成、更穩定畫質與更高可控性，適用於商業設計、行銷素材與內容生產流程。',
        keywords: 'Seedream 5.0, 字節跳動, AI圖像生成器, 8K圖像生成器, AI圖像生成, 文生圖, 語義理解, 多主體構圖, 文字渲染, WeryAI',
        og_title: 'Seedream 5.0 圖像生成器 | WeryAI',
        og_description: 'Seedream 5.0 是字節跳動在 AI 視覺領域的巔峰之作，原生 8K 超精細畫質、極致語義理解、多主體構圖與文字渲染 2.0。立即在 WeryAI 免費體驗。  支援更快生成、更穩定畫質與更高可控性，適用於商業設計、行銷素材與內容生產流程。',
        twitter_title: 'Seedream 5.0 圖像生成器 | WeryAI',
        twitter_description: 'Seedream 5.0 是字節跳動在 AI 視覺領域的巔峰之作，原生 8K 超精細畫質、極致語義理解、多主體構圖與文字渲染 2.0。立即在 WeryAI 免費體驗。  支援更快生成、更穩定畫質與更高可控性，適用於商業設計、行銷素材與內容生產流程。',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Seedream 5.0 AI 圖像生成器',
        twitterImageAlt: 'Seedream 5.0 AI 圖像生成器',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - 專業真矢量圖形生成 AI 模型 | WeryAI',
        description: 'Recraft V4 Vector 是由 Recraft.ai 推出的專業級 AI 矢量圖形生成模型，直接生成可編輯的 SVG 真矢量，支持無損縮放、精準文字排版、品牌風格控制。立即在 WeryAI 免費體驗。',
        keywords: 'Recraft V4 Vector, AI矢量圖生成, SVG生成, 真矢量, Logo設計, UI圖標, 矢量插畫, Recraft, WeryAI',
    },
    image_midjourney: {
        title: '免費 Midjourney - 立即體驗 AI 藝術生成 | WeryAI',
        description: '在 WeryAI 使用 Midjourney 創作藝術 AI 圖像！以驚豔美感與光影品質著稱。免費額度，無需綁卡。',
        keywords: 'Midjourney, Midjourney AI, AI藝術生成器, 藝術AI圖像, Midjourney 免費, Midjourney替代品, 如何使用Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI 影片生成器 - 創作電影級影片 | WeryAI',
        description: '在 WeryAI 上使用 Runway Gen-4.5 創作驚艷影片。採用自迴歸擴散混合架構，提供精準的物理模擬和時序一致性。',
        keywords: 'Runway Gen-4.5, AI影片生成器, 電影級AI影片, 物理模擬, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI 影片生成器 - 高品質影片創作 | WeryAI',
        description: '在 WeryAI 上使用 Kling 2.6 Pro 生成高品質影片。體驗原生音視訊生成、1080p 電影品質、卓越的提示詞遵循度。',
        keywords: 'Kling 2.6 Pro, AI影片生成器, 高品質AI影片, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 影片生成器 - 精確的攝影機控制和首尾幀指導 | WeryAI',
        description: '在 WeryAI 使用 Dreamina 3.0（即夢 3.0）生成電影級 AI 影片。支援首尾幀精確控制、專業運鏡和 1080p 高動態影片生成。',
        keywords: 'Dreamina 3.0, 即夢3.0, AI影片生成器, 運鏡控制, 首尾幀控制, 字節跳動AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI 影片生成器 - 創意影片生成 | WeryAI',
        description: '在 WeryAI 上釋放您的創造力，使用 Kling O1 AI 影片生成器。非常適合生成充滿想像力和獨特的影片內容。',
        keywords: 'Kling O1, AI影片生成器, 創意AI影片, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - 智慧分鏡 AI 影片生成器 | WeryAI',

        description: '快手可靈 Kling 3.0 是新一代AI影片旗艦模型，支援智慧分鏡調度、多語種口型同步、高保真文字渲染與15秒超長連貫生成。在 WeryAI 免費體驗導演級AI影片創作。',

        keywords: 'Kling 3.0, 可靈AI, 快手AI, AI影片生成器, 智慧分鏡, 多語種口型同步, 文字渲染, 文生影片, 圖生影片, 免費AI影片, WeryAI',

        og_title: 'Kling 3.0 - 智慧分鏡 AI 影片生成器 | WeryAI',

        og_description: '快手可靈 Kling 3.0 是新一代AI影片旗艦模型，支援智慧分鏡調度、多語種口型同步、高保真文字渲染與15秒超長連貫生成。在 WeryAI 免費體驗導演級AI影片創作。',

        twitter_title: 'Kling 3.0 - 智慧分鏡 AI 影片生成器 | WeryAI',

        twitter_description: '快手可靈 Kling 3.0 是新一代AI影片旗艦模型，支援智慧分鏡調度、多語種口型同步、高保真文字渲染與15秒超長連貫生成。在 WeryAI 免費體驗導演級AI影片創作。',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - 16秒聲畫同出 AI 影片生成器 | WeryAI',

        description: '生數科技 Vidu Q3 是全球首個16秒原生音影片直出模型，支援智慧分鏡自動切鏡、精準中英日文字渲染與多語種神態模擬。在 WeryAI 一鍵生成完整音影片短片，免費體驗。',

        keywords: 'Vidu Q3, 生數科技, AI影片生成器, 16秒音影片, 聲畫同出, 智慧分鏡, 文字渲染, 口型同步, 文生影片, 圖生影片, 免費AI影片, WeryAI',

        og_title: 'Vidu Q3 - 16秒聲畫同出 AI 影片生成器 | WeryAI',

        og_description: '生數科技 Vidu Q3 是全球首個16秒原生音影片直出模型，支援智慧分鏡自動切鏡、精準中英日文字渲染與多語種神態模擬。在 WeryAI 一鍵生成完整音影片短片，免費體驗。',

        twitter_title: 'Vidu Q3 - 16秒聲畫同出 AI 影片生成器 | WeryAI',

        twitter_description: '生數科技 Vidu Q3 是全球首個16秒原生音影片直出模型，支援智慧分鏡自動切鏡、精準中英日文字渲染與多語種神態模擬。在 WeryAI 一鍵生成完整音影片短片，免費體驗。',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: '免費 GPT-4o - 體驗 OpenAI 圖像生成 | WeryAI',
        description: '在 WeryAI 使用 GPT-4o 透過對話創建圖像！OpenAI 精準文字渲染與高保真效果。免費額度，無需綁卡。',
        keywords: 'GPT-4o, GPT-4o圖像, OpenAI圖像生成, 對話式AI繪畫, GPT-4o 免費, 如何使用GPT-4o生圖, WeryAI',
    },
    image_gpt_image_1_5: {
        title: '免費 GPT Image 1.5 - OpenAI 繪畫模型 | WeryAI',
        description: '在 WeryAI 使用 GPT Image 1.5 創作下一代 AI 藝術！OpenAI 最新圖像模型，創意與細節更強。免費額度，無需綁卡。',
        keywords: 'GPT Image 1.5, OpenAI圖像模型, AI藝術生成, 下一代AI圖像, GPT Image 1.5 免費, 如何使用GPT Image 1.5, WeryAI',
    },
}
